<template>
  <el-drawer
    :title="fileName || 'PDF预览'"
    :visible.sync="dialogVisible"
    size="80%"
    direction="rtl"
    append-to-body
    :close-on-click-modal="false"
    @close="handleClose"
    class="pdf-preview-drawer"
  >
    <!-- <div class="pdf-preview-header">
      <el-button type="primary" size="small" icon="el-icon-download" @click="handleDownload">下载</el-button>
      <el-button size="small" icon="el-icon-close" @click="handleClose">关闭</el-button>
    </div> -->
    <div class="pdf-preview-container">
      <iframe
        v-if="pdfUrl"
        :src="pdfUrl"
        class="pdf-iframe"
        frameborder="0"
      ></iframe>
      <el-empty v-else description="暂无PDF文件"></el-empty>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'PdfPreview',
  data() {
    return {
      dialogVisible: false,
      pdfUrl: '',
      fileName: '',
    }
  },
  methods: {
    open(row) {
      this.pdfUrl = row.url || row.file
      this.fileName = row.name
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.pdfUrl = ''
      this.fileName = ''
    },
    handleDownload() {
      if (!this.pdfUrl) {
        this.$message.warning('没有可下载的文件')
        return
      }
      const link = document.createElement('a')
      link.href = this.pdfUrl
      link.download = this.fileName || 'document.pdf'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      this.$message.success('下载已开始')
    }
  }
}
</script>

<style scoped lang="scss">
.pdf-preview-header {
  padding: 10px 20px;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  gap: 10px;
}

.pdf-preview-container {
  width: 100%;
  height: calc(100vh - 60px);
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  .pdf-iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>

<style lang="scss">
.pdf-preview-drawer {
  ::v-deep .el-drawer__header {
    padding: 10px 20px;
    margin-bottom: 0;
    border-bottom: 1px solid #e5e5e5;
  }

  ::v-deep .el-drawer__body {
    padding: 0;
    overflow: hidden;
  }
}
</style>
